import React from 'react'
import { clearCartItem} from "../../Redux/features/Cart/CartSlice"
const CheckOutPayment = ({ handlePlaceOrder }) => {
    return (
        <>
            <div className="payment ml-30 mt-3">
                <h4 className="mb-30">Payment</h4>
                <div className="payment_option">
                    <div className="custome-radio">
                        <input className="form-check-input" required type="radio" name="payment_option" id="exampleRadios4" defaultChecked />
                        <label className="form-check-label" htmlFor="exampleRadios4" data-bs-toggle="collapse" data-target="#checkPayment" aria-controls="checkPayment">Cash on delivery</label>
                    </div>
                </div>
                <div className="payment-logo d-flex">
                    <img className="mr-15" src="assets/imgs/theme/icons/payment-paypal.svg" alt />
                    <img className="mr-15" src="assets/imgs/theme/icons/payment-visa.svg" alt />
                    <img className="mr-15" src="assets/imgs/theme/icons/payment-master.svg" alt />
                    <img src="assets/imgs/theme/icons/payment-zapper.svg" alt />
                </div>
                <div className='text-center mb-3'>
                    <button className="btn btn-fill-out btn-block mt-30" onClick={handlePlaceOrder}>Place an Order<i className="fi-rs-sign-out ml-15" /></button>
                </div>
            </div>
        </>
    )
}

export default CheckOutPayment